import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/app.materials';

type ClassValue = string | string[] | Set<string> | { [klass: string]: any };

@Component({
  selector: 'app-export-control',
  standalone: true,
  templateUrl: './export-control.component.html',
  styleUrls: ['./export-control.component.scss'],
  imports: [CommonModule, MaterialModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportControlComponent {
  @Input() tooltip = 'Export as image';
  @Input() icon = 'download';
  @Input() ariaLabel?: string;
  @Input() isExporting = false;
  @Input() disabled = false;
  @Input() wrapperClass: ClassValue = '';
  @Input() buttonClass: ClassValue = '';
  @Input() spinnerDiameter = 20;
  @Input() spinnerStrokeWidth = 3;

  @Output() exportClicked = new EventEmitter<void>();

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.disabled || this.isExporting) {
      return;
    }

    this.exportClicked.emit();
  }
}

